/* tslint:disable */
/* eslint-disable */
export enum WorkProjectRealEstateTypePositionEnum {
  Inner = 'inner',
  Outer = 'outer'
}
